import { render, staticRenderFns } from "./BulmaAutocomplete.vue?vue&type=template&id=9db2d6c2&scoped=true"
import script from "./BulmaAutocomplete.vue?vue&type=script&lang=js"
export * from "./BulmaAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./BulmaAutocomplete.vue?vue&type=style&index=0&id=9db2d6c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db2d6c2",
  null
  
)

export default component.exports